//import { getBoundsFromGooglePlacesBounds } from '../../components/Map/MapUtilities';
import { getBoundsFromGooglePlacesBounds } from '../../components/Map/MapUtilities';
import { AreaType, LocationOrigin, UserLocation } from '../../interfaces/interfaces';

// TODO: refactor
export default function normalizeGeocodeResults(geoCodeResults: google.maps.GeocoderResult[]): UserLocation {

	try {
		const firstGeocodeResult: google.maps.GeocoderResult = geoCodeResults[0];
		// Determine search type (zip, county, city, other (neighborhood), address, mls#)
		// We dont need to use bbox, prefer not to, possibly show boundary on MAP NIY
		// we are extracting certain parts of Google's Geocode result based on what user is trying to search on.
		// different area types return different result object from Google 
		const { areaType, zoomLevel } = getSearchAreaType(firstGeocodeResult);

		const userLocation: UserLocation = getSearchValues(firstGeocodeResult, areaType);

		userLocation.centerMap = {
			lat: firstGeocodeResult.geometry.location.lat(),
			lng: firstGeocodeResult.geometry.location.lng()
		};

		if (firstGeocodeResult.geometry.bounds)
			userLocation.boundsElastic = getBoundsFromGooglePlacesBounds(firstGeocodeResult.geometry.bounds);

		userLocation.zoomLevel = zoomLevel;
		userLocation.areaType = areaType;

		return userLocation;
	}
	catch (error: any) {
		console.error('Geocoding Error', error);
	}
	return { initialized: false, areaType: AreaType.Geopoint, origin: LocationOrigin.UserSearch };
}

function getSearchAreaType(firstGeocodeResult: google.maps.GeocoderResult): { areaType: AreaType, zoomLevel: number } {
	if (!firstGeocodeResult.types || firstGeocodeResult?.types.length === 0)
		throw new Error('Search Problem: no geocode results (no types)');

	// Could also be a shape like bbox
	// Overall the first item in address_components is what the user searched for
	// see https://developers.google.com/maps/documentation/javascript/geocoding

	if (firstGeocodeResult.types.includes('postal_code'))
		return { areaType: AreaType.Zip, zoomLevel: 13 };
	else if (firstGeocodeResult.types.includes('administrative_area_level_2'))
		return { areaType: AreaType.County, zoomLevel: 10 };
	else if (firstGeocodeResult.types.includes('locality'))
		return { areaType: AreaType.City, zoomLevel: 12 };
	else if (firstGeocodeResult.types.includes('street_address') || firstGeocodeResult.types.includes('premise') || firstGeocodeResult.types.includes('subpremise'))
		return { areaType: AreaType.Address, zoomLevel: 17 };
	else if (firstGeocodeResult.types.includes('colloquial_area') || firstGeocodeResult.types.includes('neighborhood'))
		return { areaType: AreaType.Neighborhood, zoomLevel: 13 };
	else if (firstGeocodeResult.types.includes('administrative_area_level_1'))
		return { areaType: AreaType.State, zoomLevel: 8 };
	else
		// TODO [FE] take a good hard look at this
		return { areaType: AreaType.GeoIp, zoomLevel: 12 };
}

function getSearchValues(firstGeocodeResult: google.maps.GeocoderResult, areaType: AreaType): UserLocation {
	// Overall the first item in address_components is what the user searched for
	// With specific addressed it gets complex - keep it simple
	const userLocation: UserLocation = { initialized: true, areaType: areaType, origin: LocationOrigin.UserSearch };
	if (!firstGeocodeResult.address_components)
		throw new Error('Search Problem: No address components');

	firstGeocodeResult.address_components.forEach(field => {
		if (field.types.includes('locality'))
			userLocation.city = field.short_name?.toLowerCase();
		if (field.types.includes('administrative_area_level_1'))
			userLocation.state = field.short_name?.toLowerCase();
		if (field.types.includes('administrative_area_level_2'))
			userLocation.county = field.short_name?.toLowerCase();
		if (field.types.includes('postal_code'))
			userLocation.zip = field.short_name;
	});

	if (areaType === AreaType.Address) {
		userLocation.address = firstGeocodeResult.formatted_address.split(',')[0]?.toLowerCase();
		userLocation.formattedAddress = firstGeocodeResult.formatted_address?.toLowerCase();
	}
	return userLocation;
}

// TODO: Is this still pertinent?
/* function getSearchAreaShape(firstGeocodeResult: google.maps.GeocoderResult): string {
	if(!firstGeocodeResult.types || firstGeocodeResult?.types.length === 0) return '';

	if(firstGeocodeResult.types.includes("street_address") || firstGeocodeResult.types.includes("premise")) 
		return 'centerpoint'
	else if(firstGeocodeResult.types.includes('locality'))   
		return "area"
	else 
		return "unknown"
}
 */